<template>
  <div class="ticket">
    <md-tabs
      ref="tabs"
      class="ticket-tab"
      v-model="activeName"
    >
      <md-tab-pane name="coupon" :label="$t('coupon')">
        <coupon-index></coupon-index>
      </md-tab-pane>
      <md-tab-pane name="voucher" :label="$t('voucher')">
        <voucher></voucher>
      </md-tab-pane>
    </md-tabs>
  </div>
</template>

<script>
import { Field, InputItem, Button, Tabs, TabPane } from 'mand-mobile'
import Voucher from '@/components/user/ticket/Voucher'
import CouponIndex from '@/components/user/ticket/CouponIndex'

export default {
  i18n: {
    messages: {
      en: {
        coupon: 'Coupon',
        voucher: 'Voucher',
      },
      id: {
        coupon: 'Kupon',
        voucher: 'Voucher',
      },
    },
  },
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    CouponIndex,
    Voucher,
  },
  data() {
    return {
      activeName: 'coupon',
    }
  },
}
</script>

<style lang="stylus" scoped>
.ticket-tab /deep/ {
  .md-tab-bar {
    height: 60px;
    .md-tab-bar-inner, .scroll-view-container {
      height: 100%;
      .md-tab-bar-list {
        align-items: center;
        .md-tab-bar-item {
          height: 100%;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
